import Icon from '../components/Icon.vue'

Icon.register({"minus-square":{"width":1536,"height":1792,"paths":[{"d":"M1280 960v-128q0-26-19-45t-45-19h-896q-26 0-45 19t-19 45v128q0 26 19 45t45 19h896q26 0 45-19t19-45zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/minus-square.js
// module id = 1269
// module chunks = 0